import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [RouterLink],
  template: `
    <div class="min-h-screen flex flex-col items-center justify-center font-sans bg-[#F8F9FB] px-6 text-center">
      <div class="h-20 w-20 rounded-2xl bg-[#E7EDF6] flex items-center justify-center mb-8">
        <svg class="h-10 w-10 text-[#A6BBD1]" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </div>
      <h1 class="text-[32px] font-bold text-[#0B3558] mb-2">Espacio no encontrado</h1>
      <p class="text-[15px] text-[#476788] mb-8 max-w-sm">
        El espacio que buscas no existe o ya no está disponible.
      </p>
      <a routerLink="/explorar"
        class="inline-flex items-center gap-2 px-6 py-3 rounded-[8px] text-[14px] font-semibold
               text-white bg-[#0B3558] hover:brightness-110 transition-all duration-150
               focus:outline-none focus:ring-2 focus:ring-[#0B3558]/40">
        Ver espacios disponibles
      </a>
    </div>
  `,
})
export class NotFoundComponent {}
